import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
// import Sidebar from '../Sidebar/Sidebar';
import { FaArrowLeft, FaSpinner } from 'react-icons/fa';
// import './Staff.css';

import Breadcrumb from '../Breadcrumb';
import {  toast,ToastContainer} from 'react-toastify';

const AffiliateForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [affiliateData, setAffiliateData] = useState({
    affilate_name: '',
    email: '',
    mobile_number: '',
    address: '',
    sub_start: '',
    sub_end: ''
  });

  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(!!id);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState('');
  // const [isSidebarOpen, setIsSidebarOpen] = useState(true); 

  const routes = [
    { name: 'Home', path: '/dashboard' },
    { name: 'Affiliate', path: '/affilate' },
    { name: 'Create', path: '/affilate/create' },
    
  ];

  useEffect(() => {
    if (id) {
      const fetchAffiliate = async () => {
        try {
          const token = localStorage.getItem('token');
          const response = await axios.get(`${API_BASE_URL}view-affilate/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setAffiliateData(response.data.affilate);
          setInitialLoading(false);
        } catch (err) {
          console.error("Error fetching affiliate:", err);
          setInitialLoading(false);
        }
      };
      fetchAffiliate();
    }
  }, [id]);

  const handleChange = (e) => {
    setAffiliateData({
      ...affiliateData,
      [e.target.name]: e.target.value
    });
    setErrors({ ...errors, [e.target.name]: '' }); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({}); 
    setSuccess('');

    const token = localStorage.getItem('token');
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };
    try {
      if (id) {
        await axios.put(`${API_BASE_URL}update-affilate/${id}`, affiliateData, config);
        toast.success("Affilate Updated Successfully")
        setTimeout(() => {
          navigate('/affilate');
        }, 1500);
      } else {
        await axios.post(`${API_BASE_URL}add-affilates`, affiliateData, config);
        // setSuccess('Affiliate created successfully!');
        toast.success("Affilate Added Successfully");
        setAffiliateData({
          affilate_name: '',
          email: '',
          mobile_number: '',
          address: '',
          sub_start: '',
          sub_end: ''
        });
        setTimeout(() => {
        navigate('/affilate');
      }, 1500);
      }
   
    } catch (err) {
      if (err.response && err.response.data) {
        const { args, message } = err.response.data;

      if (args && args.length > 0) {
  const validationErrors = args[0];
  let fieldErrors = {};

  Object.keys(validationErrors).forEach((field) => {
    const errorMessage = validationErrors[field];

    
    if (Array.isArray(errorMessage)) {
      fieldErrors[field] = errorMessage.join(' ');
    } else if (typeof errorMessage === 'string') {
      fieldErrors[field] = errorMessage;
    } else {
      fieldErrors[field] = 'Invalid input'; 
    }
  });

  setErrors(fieldErrors);
}
 else {
          setErrors({ form: message || 'Error occurred. Please try again.' });
        }
      } else {
        setErrors({ form: id ? 'Error updating affiliate. Please try again.' : 'Error creating affiliate. Please try again.' });
      }
      setLoading(false);
    }
  };

  // const toggleSidebar = () => {
  //       setIsSidebarOpen(!isSidebarOpen); 
  //   };

  if (initialLoading) {
    return (
      <div className="d-flex">
        <div className='container my-5 flex-grow-1'>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex">
     
      <div className="container my-1 flex-grow-1">
      <div className='d-flex'>
      <Breadcrumb routes = {routes}/>
      <button className="btn ls-btn ms-auto" style={{width:'120px',height:'50px'}} onClick={() => navigate('/affilate')}>
        <FaArrowLeft /> Back
      </button>
      </div>
      <div className="card-header text-dark">
        <h3 className="mb-0">{id ? 'Update Affiliate' : 'Create Affiliate'}</h3>
        </div>
        <ToastContainer/>
        <div className="card white-box-shadow mt-4">
            {/* <div className="card-header bg-primary text-white py-3">
            <h3 className="mb-0">{id ? 'Update Affiliate' : 'Create Affiliate'}</h3>
          </div> */}
          <div className="card-body">
            {/* {loading && (
              <div className="alert alert-info d-flex align-items-center">
                <FaSpinner className="spin me-2" /> {id ? 'Updating...' : 'Submitting...'}
              </div>
            )} */}
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
            {success && <div className="alert alert-success">{success}</div>}
           
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="affilate_name" className="form-label">
                      Name: <span className="text-danger">*</span>
                    </label>
                  <div className="input-group">
                    {/* <span className="input-group-text"><i className="bi bi-person"></i></span> */}
                    <input
                      type="text"
                      id="affilate_name"
                      name="affilate_name"
                      className="form-control"
                      placeholder="Enter affiliate name"
                      value={affiliateData.affilate_name}
                      onChange={handleChange}
                    />
                  
                  </div>
                     {errors.affilate_name && <div className="text-danger">{errors.affilate_name}</div>}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="email" className="form-label">Email: <span className="text-danger">*</span></label>
                  <div className="input-group">
                    {/* <span className="input-group-text"><i className="bi bi-envelope"></i></span> */}
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Enter email"
                      value={affiliateData.email}
                      onChange={handleChange}
                      disabled={!!id}
                    />
                   
                  </div>
                   {errors.email && <div className="text-danger">{errors.email}</div>}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="mobile_number" className="form-label">Mobile Number:</label>
                  <div className="input-group">
                    {/* <span className="input-group-text"><i className="bi bi-phone"></i></span> */}
                    <input
                      type="tel"
                      id="mobile_number"
                      name="mobile_number"
                      className="form-control"
                      placeholder="Enter mobile number"
                      value={affiliateData.mobile_number}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.mobile_number && <div className="text-danger">{errors.mobile_number}</div>}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="address" className="form-label">Address:</label>
                  <div className="input-group">
                    {/* <span className="input-group-text"><i className="bi bi-geo-alt"></i></span> */}
                    <input
                      type="text"
                      id="address"
                      name="address"
                      className="form-control"
                      placeholder="Enter address"
                      value={affiliateData.address}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.address && <div className="text-danger">{errors.address}</div>}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label htmlFor="sub_start" className="form-label">Subscription Start Date:</label>
                  <input
                    type="date"
                    id="sub_start"
                    name="sub_start"
                    className="form-control"
                    value={affiliateData.sub_start}
                    onChange={handleChange}
                  />
                  {errors.sub_start && <div className="text-danger">{errors.sub_start}</div>}
                </div>
                <div className="col-md-6 mb-3">
                  <label htmlFor="sub_end" className="form-label">Subscription End Date:</label>
                  <input
                    type="date"
                    id="sub_end"
                    name="sub_end"
                    className="form-control"
                    value={affiliateData.sub_end}
                    onChange={handleChange}
                  />
                  {errors.sub_end && <div className="text-danger">{errors.sub_end}</div>}
                </div>
              </div>
              <div className="d-grid col-2 mx-auto mt-4">
                <button type="submit" className="btn ls-btn btn-lg" disabled={loading}>
                  {loading ? (
                    <>
                      <FaSpinner className="spin me-2" /> {id ? 'Updating...' : 'Submitting...'}
                    </>
                  ) : (
                    id ? 'Update' : 'Submit'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
     
      </div>
  );
};

export default AffiliateForm;
